import {
  Box,
  Button,
  Flex,
  FormControl,
  Heading,
  Input,
  Text,
  useColorModeValue,
  useToast,
} from '@chakra-ui/react';
import CenteredAuth from 'layouts/auth/variants/Centered';
import React, { useState } from 'react';
import { useNavigate,  } from 'react-router-dom';
import { authRepository } from 'api/authRepository';

function Verification() {
  const navigate = useNavigate();
  const [code, setCode] = useState('');
  const toast = useToast();

  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const textColorSecondary = 'gray.400';
  const borderColor = useColorModeValue('secondaryGray.400', 'whiteAlpha.100');
  const textColorDetails = useColorModeValue('navy.700', 'secondaryGray.600');
  const textColorBrand = useColorModeValue('brand.500', 'white');

const handleVerifyEmail = async () => {
  try {
    await authRepository.verifyEmail(code);
    navigate('/auth/new-password');
   toast({
    title: 'Email verified successfully',
    duration: 3000,
    position: 'top',
    status: "success",
    isClosable: true
   })
  } catch (error) {
    toast({
      title: "Failed Email Verification",
      status : "error",
      duration: 3000,
      position: 'top',
      isClosable: true
    })
  }
};


  return (
    <CenteredAuth cardTop={{ base: '140px', md: '24vh' }} cardBottom={{ base: '50px', lg: 'auto' }}>
      <Flex
        w="100%"
        maxW="max-content"
        mx={{ base: 'auto', lg: '0px' }}
        me="auto"
        h="100%"
        justifyContent="center"
        px={{ base: '25px', md: '0px' }}
        flexDirection="column"
      >
        <Box me="auto" mb="34px">
          <Heading color={textColor} fontSize="36px" mb="16px" textAlign="center">
            2-Step Verification
          </Heading>
          <Text color={textColorSecondary} fontSize="md" textAlign="center">
            Enter your 2-Step Verification email code to Register!
          </Text>
        </Box>

        <Flex
          direction="column"
          w={{ base: '100%', md: '425px' }}
          background="transparent"
          borderRadius="15px"
          mx="auto"
          mb={{ base: '20px', md: 'auto' }}
        >
          <FormControl>
            <Input
              type="text"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              placeholder="Enter verification code"
              fontSize="20px"
              textAlign="center"
              color={textColor}
              borderRadius="16px"
              borderColor={borderColor}
              h={{ base: '55px', md: '60px' }}
              mb="16px"
              maxLength={36}
            />

            <Button
              fontSize="14px"
              variant="brand"
              borderRadius="16px"
              fontWeight="500"
              w="100%"
              h="50"
              mb="24px"
              onClick={handleVerifyEmail}
            >
              Verify
            </Button>
          </FormControl>

          <Flex flexDirection="column" justifyContent="center" alignItems="center">
            <Text color={textColorDetails} fontWeight="400" fontSize="14px">
              Haven't received it?
              <Text color={textColorBrand} as="span" ms="5px" fontWeight="500" cursor="pointer">
                Resend a new code
              </Text>
            </Text>
          </Flex>
        </Flex>
      </Flex>
    </CenteredAuth>
  );
}

export default Verification;
